module.exports = __webpack_public_path__ + "img/EVENT.f4c964ee.svg";